import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {NgbModule, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { AuthGuard } from './auth.guard';
import { CommonService } from '../services/commonService';
import { BackOfficeService } from '../services/backOfficeService';
import { SvlServices } from '../services/svlServices';
import { TranslationLoaderService } from '../services/translationLoader.service';
import { NgxCaptchaModule } from 'ngx-captcha';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ApiManager } from '../services/api-manager.service';
import { SecurityAccessDirective } from '../services/security-access.directive';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { SharedModule } from './common/common.module';
import { NumberDirective } from '../assets/directives/numbers-only.directive';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { MomentDateFormatter } from '../assets/directives/dateParser';
import { CookieService, CookieModule } from 'ngx-cookie'; 
import { MyDatePickerModule  } from 'mydatepicker';
import { LoaderComponent } from './loader/loader.component';
import { CustomValidatorsService } from './customValidatorService';
import { SportsBettingComponent } from './sports-betting/sports-betting.component';
import { VirtualBettingComponent } from './virtual-betting/virtual-betting.component';
import { LiveBettingComponent } from './live-betting/live-betting.component';
import { JustBetHomepgeComponent } from './just-bet-homepge/just-bet-homepge.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { HomeScreenComponent } from './home-screen/home-screen.component';
import { GuyanaHomeScreenComponent } from './guyana-home-screen/guyana-home-screen.component';
import { GuyanaReportsModule } from './guyana-reports/guyana-reports.module';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    SecurityAccessDirective,
    NumberDirective,
    SportsBettingComponent,
    VirtualBettingComponent,
    LiveBettingComponent,
    JustBetHomepgeComponent,
    HomeScreenComponent,
    GuyanaHomeScreenComponent
  ],
  imports: [
    MyDatePickerModule ,
    BrowserAnimationsModule ,
    NgbModule,
    FormsModule,
    RouterModule,
    SharedModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    NgxBarcodeModule,
    NgIdleKeepaliveModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClientModule]
      }
    }),
    AngularFontAwesomeModule,
    AppRoutingModule, 
    MDBBootstrapModule.forRoot(),
    CookieModule.forRoot(),
  ],
  providers: [CustomValidatorsService, CookieService, AuthGuard, CommonService, BackOfficeService, SvlServices, TranslationLoaderService, ApiManager, {provide: NgbDateParserFormatter, useValue: new MomentDateFormatter()}],
  bootstrap: [AppComponent],
})
export class AppModule { }

